import { useFormats } from "@portal/hooks/use-formats";
import { Icon } from "@portal/lib/icons/icons";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { useAtomValue } from "jotai";
import { Flex } from "../Flex/Flex";
import { Popover } from "../PopOver/AntPopOver";
import { Amount } from "./Amount";
import { MultiCurrencyData } from "./MultiCurrencyData";
import { ExchangeIcon } from "./style";
import { AmountWithCurrencySplitProps } from "./types";
import {
  canShowCurrencySplitPopup,
  changeToMultiCurrencyFormat,
} from "./utils";

export const overlayStyles: React.CSSProperties = {
  width: "260px",
  borderRadius: "var(--br-3)",
  boxShadow: "var(--shadow-2) var(--shadow-2)",
  border: "1px solid var(--gray-4)",
  background: "var(--gray-1)",
};
function AmountWithCurrencySplit(props: AmountWithCurrencySplitProps) {
  const accBaseCurrency =
    useAtomValue(userConfigAtom).user_details?.customer.currency;
  const { locale } = useFormats();
  function assignValues() {
    if (props.type === "single") {
      return changeToMultiCurrencyFormat(
        props.amount,
        props.currency,
        props.baseAmount,
        props.baseCurrency ?? accBaseCurrency ?? "USD"
      );
    }

    return props.amountWithCurrencySplit;
  }

  const values = assignValues();

  if (!values || !Object.keys(values).length) return null;
  const { value, currency, multi_currency_split } = values;

  const AmountComp = (
    <Amount
      amount={value}
      currency={currency}
      className={props.className}
      style={props.style}
      styledComponent={props.styledComponent}
      formatOptions={props.formatOptions}
      context={props.context}
      showTooltip={
        !canShowCurrencySplitPopup(multi_currency_split, value) &&
        props.showTooltip
      }
      locale={locale}
    />
  );

  const CurrencyData = (
    <MultiCurrencyData
      multiCurrencySplit={multi_currency_split ?? []}
      splitTotal={{ amount: value, currency }}
    />
  );

  const MultiIcon = (
    <ExchangeIcon>
      <Icon
        color="var(--geekblue-6)"
        icon={["far", "exchange"]}
        fontSize={12}
      />
    </ExchangeIcon>
  );

  return (
    <Flex align="center" justify="start" space={"4"}>
      {AmountComp}
      {multi_currency_split &&
        canShowCurrencySplitPopup(multi_currency_split, value) && (
          <Popover
            placement="rightTop"
            content={CurrencyData}
            arrow={false}
            overlayInnerStyle={{ background: "transparent" }}
            overlayStyle={overlayStyles}
          >
            {MultiIcon}
          </Popover>
        )}
    </Flex>
  );
}

export { AmountWithCurrencySplit };
